import AuthService from './AuthService';
import Config from '../config';
import Feature from '../../design/models/Feature';
import { SkinTheme } from 'design/models/SkinTheme';
import { SkinThemeOptionKey } from '../../design/models/SkinTheme';
import { get } from 'lodash';

export const DefaultSkinThemeOptions: SkinTheme = {
  container: {
    siteName: 'Bracken',
    headerColor: '#222'
  }
};

class SkinThemeService {
  public getThemeOptionValue(
    skinTheme: SkinTheme,
    featurekey: Feature,
    optionkey: SkinThemeOptionKey
  ) {
    const path = `${featurekey}.${optionkey}`;
    return get(skinTheme, path) || get(DefaultSkinThemeOptions, path);
  }

  public getAssetUrl(featurekey: Feature, optionkey: SkinThemeOptionKey) {
    return `${Config.DESIGN_DS}/api/theme/${AuthService.Tenant}/features/${featurekey}/${optionkey}`;
  }
}

export default new SkinThemeService();
